import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CButton, CCloseButton } from '@coreui/react-pro';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Waiting from '../../General/Loadings/Waiting';
import { setShowEditPopup, setShowPopupDetail } from '../../../actions/general';
import { useIsSupperAdmin } from '../../../helpers/customHook';
import { DEFAULT_FN } from '../../../constants';

const DetailsPopup = ({
     object,
     formId,
     children,
     title,
     description,
     buttonName,
     className,
     classNameBody,
     allowEdit,
     disabled,
     onClose,
     onCancel,
}) => {
     const dispatch = useDispatch();
     const isWaiting = useSelector((state) => state.general.isWaiting);
     const showEditPopup = useSelector((state) => state.general.showEditPopup);
     const showPopupDetail = useSelector((state) => state.general.showPopupDetail);
     const isSupperAdmin = useIsSupperAdmin();

     const newAllowEdit = allowEdit !== undefined ? allowEdit : isSupperAdmin;

     const handleCancelButtonClick = () => {
          if (showEditPopup) {
               dispatch(setShowEditPopup(null));
          }

          if (showPopupDetail) {
               dispatch(setShowPopupDetail(null));
          }

          onCancel();
          onClose();
     };

     return (
          <CModal visible={true} alignment="center" className={classNames('admin-popup-form', { [className]: className })} onClose={onClose}>
               <CModalHeader closeButton={false}>
                    <CModalTitle>{title ?? `Edit ${object}`}</CModalTitle>
                    <CCloseButton onClick={handleCancelButtonClick} />
               </CModalHeader>
               <CModalBody className={classNameBody}>
                    {description && <p className="modal-description">{description}</p>}
                    {children}
               </CModalBody>
               {newAllowEdit && (
                    <CModalFooter>
                         <div className="modal-footer-start">
                              <CButton type="submit" color="primary" className="me-3" form={formId} disabled={isWaiting || disabled}>
                                   <Waiting isLoading={isWaiting}>{buttonName}</Waiting>
                              </CButton>
                              <CButton color="secondary" onClick={handleCancelButtonClick}>
                                   Cancel
                              </CButton>
                         </div>
                    </CModalFooter>
               )}
          </CModal>
     );
};

DetailsPopup.propTypes = {
     object: PropTypes.string,
     formId: PropTypes.string,
     children: PropTypes.any,
     title: PropTypes.string,
     description: PropTypes.string,
     buttonName: PropTypes.string,
     disabled: PropTypes.bool,
     allowEdit: PropTypes.bool,
     className: PropTypes.string,
     classNameBody: PropTypes.string,
     onClose: PropTypes.func,
};

DetailsPopup.defaultProps = {
     buttonName: 'Save changes',
     onClose: DEFAULT_FN,
     onCancel: DEFAULT_FN,
};

export default DetailsPopup;
